import * as modificationPackageFormNames from "./modificationPackageFormNames";

export const modificationPackageInitialValues = {
  [modificationPackageFormNames.STATUS_PACKAGE_FORM_NAME]: "",
  [modificationPackageFormNames.DESCRIPTION_FORM_NAME]: "",
};
